import { ADD_POPUP, LAYER } from '@core/js/components/common/PopupManager';
import { CommonPopup } from '@core/js/components/common/popups/CommonPopup';
import { ShowPopupWithClassProps } from './types';

export const showCommonPopupWithClass = ({
    id,
    title,
    content,
    onClose,
    btnTitle,
    closeAll,
    layer = LAYER.COMMON,
    isModal = false,
    articleId,
    buttons,
    className,
    ...other
}: ShowPopupWithClassProps) => ({
    type: ADD_POPUP,
    payload: {
        id,
        component: CommonPopup,
        title,
        content,
        onClose,
        btnTitle,
        closeAll,
        layer,
        isModal,
        articleId,
        buttons,
        className,
        ...other
    }
});

